import cn from 'classnames'
import React from 'react'

const Pagination = ({ result, offset, limit, location, setOffset }) => {
    const currentPage = Math.round(offset / limit)
    
  const itemClass = cn(
        'flex w-8 h-8 justify-center dark:text-white text-black',
        'cursor-pointer bg-zinc-300 dark:!bg-zinc-900 rounded-2xl opacity-85 hover:bg-primaryt',
        { 'mx-1': currentPage > 0 },
        { 'mx-4': currentPage === 0 },
    )

    const itemClassUnderlined = cn(
        'flex w-8 h-8 justify-center dark:text-white text-black',
        'cursor-pointer bg-primaryt rounded-2xl',
        { 'mx-1': currentPage > 0 },
        { 'mx-4': currentPage === 0 },
    )

    const pClass = 'my-auto w-8 text-center'

    if (result && (result.length === limit || offset > 1))
        return (
            <div
                className={cn(
                    'flex justify-evenly',
                    'w-auto color-neutral h-10 mt-2 xl:mt-0',
                    { 'mb-10': location === 'Bottom' },
                    { 'mb-auto': location === 'Top' },
                )}
            >
                {currentPage > 0 ? (
                    <div className={itemClass} onClick={() => setOffset(0)}>
                        <p className={pClass}>&lt;&lt;</p>
                    </div>
                ) : (
                    ''
                )}
                {currentPage > 0 ? (
                    <div
                        className={itemClass}
                        onClick={() => setOffset((currentPage - 1) * limit)}
                    >
                        <p className={pClass}>&lt;</p>
                    </div>
                ) : (
                    ''
                )}
                {currentPage > 0 ? (
                    <div
                        className={itemClass}
                        onClick={() => setOffset((currentPage - 1) * limit)}
                    >
                        <p className={pClass}>{currentPage}</p>
                    </div>
                ) : (
                    ''
                )}
                <div
                    className={itemClassUnderlined}
                    key={`Pagination${currentPage}`}
                    onClick={() => setOffset(currentPage * limit)}
                >
                    <p className={pClass}>{currentPage + 1}</p>
                </div>
                {result.length === limit ? (
                    <div
                        className={itemClass}
                        onClick={() => setOffset((currentPage + 1) * limit)}
                    >
                        <p className={pClass}>{currentPage + 2}</p>
                    </div>
                ) : (
                    ''
                )}
                {result.length === limit ? (
                    <div
                        className={itemClass}
                        onClick={() => setOffset((currentPage + 1) * limit)}
                    >
                        <p className={pClass}>&gt;</p>
                    </div>
                ) : (
                    ''
                )}
            </div>
        )
    else
        return (
            <div
                className={cn(
                    'flex text-right justify-evenly',
                    'w-1/2 color-neutral h-6 m-auto',
                )}
            ></div>
        )
}

export default Pagination
